export const LAYOUT_OPTIONS_QUERY = {
  QUESTIONS: 'content_tests',
  THEORIE: 'content',
  VIDEO: 'video',
  GEVAARHERKENNING: 'gevaarherkenning',
  DRAG_AND_DROP: 'pointers',
  NUMERIC: 'numeric',
  PICTURE_SELECT: 'picture_select',
}
export const LAYOUT_OPTIONS = [
  {
    name: 'Question',
    query: LAYOUT_OPTIONS_QUERY.QUESTIONS
  },
  {
    name: 'Video',
    query: LAYOUT_OPTIONS_QUERY.VIDEO
  },
  {
    name: 'Theorie',
    query: LAYOUT_OPTIONS_QUERY.THEORIE
  },
  {
    name: 'Question Gevaarhrkenning',
    query: LAYOUT_OPTIONS_QUERY.GEVAARHERKENNING
  },
  {
    name: 'Drag and Drop',
    query: LAYOUT_OPTIONS_QUERY.DRAG_AND_DROP
  },
  {
    name: 'Numeric',
    query: LAYOUT_OPTIONS_QUERY.NUMERIC
  },
  {
    name: 'Picture Select',
    query: LAYOUT_OPTIONS_QUERY.PICTURE_SELECT
  }
]

export const TYPE_OPTIONS = [
  {
    query: 'GEVAARHERKENNING',
    name: 'Gevaarherkenning'
  },
  {
    query: 'KENNIS',
    name: 'Kennis'
  },
  {
    query: 'INZICHT',
    name: 'Inzicht'
  }
]

export const PREFILL_GEVAARHERKENNING_VALUES = {
  name: 'oefenvragen',
  title: 'Oefenvragen!!!',
  choices: [
    {title: "A. Remmen"},
    {title: "B. Gas loslaten"},
    {title: "C. Niets"},
  ],
}
export const PREFILL_GEVAARHERKENNING_EMPTY_STATEMENTS = [
  undefined,
  "''",
  '""',
  '',
  'null',
  '[]',
  '[{},{},{}]',
  '{}',
]

export const MEASUREMENT_UNITS = ['jaar', 'uren', 'minuten', 'seconden', 'kg', 'km/u', 'm', 'cm', 'personen'];